import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardActions, IconButton } from '@mui/material';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import './ChatUI.scss';
import { IconBack, IconMessages, IconRefresh, IconSend, IconRecord, IconAttach } from "re_redesigned_componnents/icon";
import {
    withApiContext
} from "context";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const Chat = (props) => {
    const [selectedUser, setSelectedUser] = useState(null);
    const [sections, setSections] = useState(null);
    const [isRotating, setIsRotating] = useState(false);
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(null)
    const [text, setText] = useState('');
    const [mediaRecorder, setMediaRecorder] = useState(null);
    const [isRecording, setIsRecording] = useState(false);
    const [audioChunks, setAudioChunks] = useState([]);
    const [audioFile, setAudioFile] = useState(null); // File object
    const [audioUrl, setAudioUrl] = useState(null);
    const [attachedImageUrl, setAttachedImageUrl] = useState(null);
    const history = useHistory();
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        setLoading(true);
        getMessages();
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    const handleRefresh = () => {
        setIsRotating(true);
        getMessages();

        // Stop rotation after 1s (or after getMessages completes if async)
        setTimeout(() => {
            setIsRotating(false);
        }, 1000);
    };

    const getMessages = () => {
        props.ctx_api
            .privateRequest({
                cmd: "get_ask_trainer_messages",
                // args: { testAssessmentId: assessmentid.toString() },
            })
            .then(({ rsp }) => {
                let downloadUrl = handlegetMessagesResponse(rsp);

            })
        //   .catch(handleGetTrainerAssessmentsFailure);
    };

    const handlegetMessagesResponse = (rsp) => {
        console.log(rsp[0].message, "dsfg")
        const users = rsp[0].message.map(item => ({
            ...item,
            messages: [
                { sender: 'You', message: item.query_field, asked_on: item.asked_on },
                { sender: item.sender_name, message: item.reply, replied_on: item.replied_on }
            ]
        }));
        setLoading(false);
        setSections(users)

    }
    const handleRecordStart = async () => {
    try {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        const recorder = new MediaRecorder(stream);
        let chunks = [];

        recorder.ondataavailable = (e) => {
            if (e.data.size > 0) {
                chunks.push(e.data);
            }
        };

        recorder.onstop = async () => {
            const blob = new Blob(chunks, { type: 'audio/webm' });

            // Read blob into ArrayBuffer for File constructor
            const buffer = await blob.arrayBuffer();

            // Create File from buffer (convert to Uint8Array)
            const file = new File([new Uint8Array(buffer)], "newaudio.webm", {
                type: blob.type,
                lastModified: Date.now(),
            });

            const blobURL = URL.createObjectURL(blob);

            setAudioFile(file);
            setAudioUrl(blobURL);
            setAudioChunks([]); // cleanup
        };

        recorder.start();
        setMediaRecorder(recorder);
        setAudioChunks([]);
        setIsRecording(true);
    } catch (err) {
        console.error("Recording start failed:", err);
    }
};


    const handleRecordStop = () => {
    if (mediaRecorder) {
        mediaRecorder.stop();
        setIsRecording(false);
        console.log("Recording stopped");
    }
};

    const handleSubmit = (e) => {
        sendMessage();
    };
    const sendMessage = () => {
        const args = {
            chapterId: data.chapter_id,
            courseId: data.course_id,
            coursePublishId: data.course_publish_id,
            curriculumId: data.curriculum_id,
            memberId: data.member_id,
            message: text,
            refreshFromTimestamp: data.fetch_timestamp,
            videoUnitId: data.video_unit_id,
            audioFile: audioFile? audioFile:null,
            attachedImageUrl: attachedImageUrl? attachedImageUrl:null
        };

        props.ctx_api
            .privateRequest({
                cmd: "insert_update_ask_trainer_then_refresh",
                args: args
            })
            .then(({ rsp }) => {
                setText('')
                console.log(rsp[0].message[0]);
                console.log(sections)
                getMessages()
                // setSections(prev => [...prev, rsp[0].message[0]])
                console.log(sections)
            });
    };


    const handleAttachFile = () => {
    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.accept = "image/*"; // Only allow images

    fileInput.onchange = (e) => {
        const file = e.target.files[0];
        if (!file || !selectedUser) return;

        const reader = new FileReader();
        reader.onload = () => {
            const base64Image = reader.result; // This will be the Base64 string
            setAttachedImageUrl(base64Image); // Store it in state for preview or sending
        };
        reader.readAsDataURL(file); // Converts file to base64
    };

    fileInput.click();
};


    const uniqueSections = Array.from(
        new Map(sections && sections.map(item => [item.video_unit_id, item])).values()
    );
    const handleUserSelect = (videoUnitId,userdata) => {
        setData(userdata)
        setSelectedUser(videoUnitId);
    };
    console.log(uniqueSections, "cxv")
    const formatReplyTime = (dateString) => {
        const replyDate = new Date(dateString);
        const now = new Date();
        const diffMs = now - replyDate;
        const diffHours = diffMs / (1000 * 60 * 60);

        if (diffHours <= 24) {
            return replyDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        } else if (diffHours <= 48) {
            return 'Yesterday';
        } else {
            return replyDate.toLocaleDateString();
        }
    };
    function formatDate(datetimeString) {
        const date = new Date(datetimeString);

        const day = date.getDate();
        const month = date.toLocaleString('default', { month: 'long' }); // e.g., "February"
        const hours = String(date.getHours()).padStart(2, '0'); // e.g., "14"
        const minutes = String(date.getMinutes()).padStart(2, '0'); // e.g., "27"

        return `${day}, ${month}, ${hours}:${minutes}`;
    }
    console.log((isMobile && selectedUser))
    console.log(!isMobile)

    return uniqueSections && (
        <div className="chat-ui-container">
            {/* Left Sidebar */}
            {(!isMobile || (isMobile && !selectedUser)) && (
                <Card className="chat-sidebar">
                    <CardContent className="chat-sidebar-content">
                        <div className="sidebar-header" onClick={() => { history.push("/"); }}>
                            <IconButton className="back-button" >
                                <IconBack />
                            </IconButton>
                            <h2 className="sidebar-title">Back</h2>
                        </div>
                        <div className="horizontal-container1">
                            <div className="left-section">
                                <IconMessages />
                                <h2 className="sidebar-title">Messages</h2>
                            </div>
                            <div className={`refresh-icon ${isRotating ? 'rotating' : ''}`} onClick={handleRefresh}>
                                <IconRefresh />
                            </div>

                        </div>
                        {loading ? (
                            <div className="spinner"></div>
                        ) :
                            <div className="user-list-container">
                                {uniqueSections.map((user, index) => (
                                    <div
                                        key={user.video_unit_id + '_' + index}
                                        className={`user-item ${selectedUser === user.video_unit_id ? 'selected' : ''}`}
                                        onClick={() => handleUserSelect(user.video_unit_id,user)}
                                    >
                                        <div className="user-left">
                                            <img
                                                src={user.user_image || '/default-profile.png'}
                                                alt={user.sender_name || 'Unknown'}
                                                className="user-profile-pic"
                                            />
                                            <div>
                                                <h3 className="user-name">{user.sender_name || 'You'}</h3>
                                                <p className="user-last-message">Module - {user.module_name}</p>
                                            </div>
                                        </div>
                                        <div className="user-right">
                                            <p className="user-time">
                                                {user.replied_on ? formatReplyTime(user.replied_on) : formatReplyTime(user.asked_on)}
                                            </p>
                                            <span className="message-count">{user.has_reply ? 1 : 0}</span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        }
                    </CardContent>
                </Card>
            )}

            {/* Chat Area */}
            {(!isMobile || (isMobile && selectedUser)) && (
                <Card className="chat-area">
                    <CardContent className="chat-content">
                        <div className="chat-headers">
                            {selectedUser ? (() => {
                                const selectedUserObj = uniqueSections.find(user => user.video_unit_id === selectedUser);
                                return (
                                    <div className="user-info">
                                        {isMobile && <div style={{ cursor: 'pointer' }} onClick={() => { history.push("/"); }}>
                                            <IconButton className="back-button" >
                                                <IconBack />
                                            </IconButton>
                                        </div>}
                                        <img
                                            src={selectedUserObj?.user_image || 'default-avatar.jpg'}
                                            alt="Profile"
                                            className="profile-picture"
                                        />

                                        <div className="user-details">
                                            <h2 className="user-name">
                                                {selectedUserObj?.sender_name || 'You'}
                                            </h2>
                                            <p className="user-role">
                                                Module - {selectedUserObj?.module_name
                                                    || 'No role defined'}
                                            </p>
                                        </div>
                                    </div>
                                );
                            })() : (
                                <h2 className="placeholder-text">Select a conversation</h2>
                            )}
                        </div>
                        {selectedUser && Array.isArray(sections) && (
                            <div className="chat-messages">
                                <div className="chat-messages">
                                    {(() => {
                                        const matchingChats = sections.filter(chat => chat.video_unit_id === selectedUser);
                                        console.log(sections)
                                        console.log(matchingChats)
                                        const allMessages = matchingChats.flatMap((chatObj, objIndex) => {
                                            return (chatObj.messages || []).map((chat, msgIndex) => {
                                                const timestampStr = chat.replied_on || chat.asked_on;
                                                const timestamp = timestampStr ? new Date(timestampStr) : new Date();
                                                return {
                                                    ...chat,
                                                    timestamp
                                                };
                                            });
                                        });
                                        allMessages.sort((a, b) => a.timestamp - b.timestamp);
                                        return allMessages.map((chat, index) => (
                                            <div key={index}>
                                                <div className={`message-wrapper ${chat.sender === 'You' ? 'outgoing-wrapper' : 'incoming-wrapper'}`}>
                                                    {chat.sender === 'You' && (
                                                        <img
                                                            src={'your-profile-picture.jpg'}
                                                            alt="You"
                                                            className="message-profile-picture"
                                                        />
                                                    )}
                                                    {chat.message && (
                                                        <div className={`message ${chat.sender === 'You' ? 'outgoing' : 'incoming'}`}>
                                                            <p>{chat.message}</p>
                                                            <span className="message-time">{formatDate(chat.timestamp)}</span>
                                                        </div>
                                                    )}
                                                    {chat.sender !== 'You' && chat.message && (
                                                        <img
                                                            src={'your-profile-picture.jpg'}
                                                            alt="You"
                                                            className="message-profile-picture"
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                        ));
                                    })()}
                                </div>
                            </div>
                        )}
                    </CardContent>
                    <div className="chat-container">
                        {selectedUser && (
                            <CardActions className="chat-input-container" style={audioFile || attachedImageUrl? {justifyContent:'space-between'}:null}>
                                {isRecording ? (
                                    <div className="recording-ui">
                                        <span>Recording...</span>
                                        <button onClick={handleRecordStop} className="stop-recording-btn">
                                            Stop
                                        </button>
                                    </div>
                                ) : (
                                    <>
                                            {audioFile && (
                                                <div className="audio-message-bubble">
                                                    <div className="audio-content">
                                                        <audio controls src={audioUrl} />
                                                        <span className="audio-filename">{audioFile.name}</span>
                                                    </div>
                                                </div>
                                            )}
                                            {attachedImageUrl && (
                                                <div className="image-preview">
                                                    <img src={attachedImageUrl} alt="Preview" />
                                                    <button className="remove-preview" onClick={() => setAttachedImageUrl(null)}>✕</button>
                                                </div>
                                            )}
                                         {!attachedImageUrl &&( <>
                                        <TextField
                                            className="chat-input"
                                            placeholder="Type Your Message..."
                                            fullWidth
                                            variant="standard"
                                            value={text}
                                            onChange={(e) => setText(e.target.value)}
                                            InputProps={{
                                                disableUnderline: true,
                                                style: { color: "white" },
                                            }}
                                        />
                                        <IconRecord
                                            color="primary"
                                            onMouseDown={handleRecordStart}
                                        />
                                        <IconAttach color="primary" onClick={handleAttachFile} /> </>)}
                                        <IconSend style={{cursor:'pointer'}} color="primary" onClick={handleSubmit}/>
                                    </>
                                )}
                            </CardActions>
                        )}</div>
                </Card>
            )}
        </div>
    );
};

export default withApiContext(Chat);
